module.exports = __webpack_public_path__ + "img/boot-heeled.0d96e379.svg";